/*
 * @Date: 2022-09-26 17:08:20
 * @LastEditors: guantingting
 * @LastEditTime: 2022-09-28 18:00:06
 */
export default [
  {
    path: '/rent/v2/comprehensive-camp/comprehensive-detail',
    name: 'comprehensiveProduct',
    component: () => import('@/pages/comprehensiveCamp/comprehensiveProduct'),
    meta: { title: '套餐详情', requireAuth: true },
  },
  {
    path: '/rent/v2/comprehensive-camp/comprehensive-calender',
    name: 'comprehensiveCalender',
    component: () => import('@/pages/comprehensiveCamp/comprehensiveCalender'),
    meta: { title: '使用时间', requireAuth: true },
  }
]


// WEBPACK FOOTER //
// ./src/pages/comprehensiveCamp/comprehensiveCamp.js